import React from 'react';
import styled from 'styled-components';
import { PencilSquareIcon } from '@heroicons/react/24/solid';
import { TiHome } from 'react-icons/ti';
import { FaBook } from 'react-icons/fa';
import { MdOutlinePeopleAlt } from 'react-icons/md';
import { IoMdPerson } from 'react-icons/io';

const TabBar = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100vw;
  box-sizing: border-box;
  height: 64px;
  background: #eae8e9;
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 100;
`;
const TabItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${({ active }) => (active ? '#333333' : '#bbb')};
  font-size: 12px;
  cursor: pointer;
`;
const TabIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  margin-bottom: 2px;
`;

const tabs = [
  { key: 'home', icon: <TiHome size={24} />, label: '홈' },
  { key: 'nudok', icon: <FaBook size={22} />, label: '누독' },
  { key: 'nupil', icon: <PencilSquareIcon style={{ width: 24, height: 24 }} />, label: '누필' },
  { key: 'moim', icon: <MdOutlinePeopleAlt size={24} />, label: '모임' },
  { key: 'mypage', icon: <IoMdPerson size={24} />, label: '내정보' },
];

const BottomTab = ({ selected, onTabChange }) => {
  return (
    <TabBar>
      {tabs.map(tab => (
        <TabItem
          key={tab.key}
          active={selected === tab.key}
          onClick={() => onTabChange(tab.key)}
        >
          <TabIcon>
            {tab.icon}
          </TabIcon>
          {tab.label}
        </TabItem>
      ))}
    </TabBar>
  );
};

export default BottomTab; 